"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIcon = require("@cdk-uip/react-icon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Renders a caption with a back icon and text. Used to return
 * to a home page or portal landing page.
 *
 * Refer [AppSwitcher](#appswitcher) component for example and usage
 */


var AppSwitcherHome = function (_React$Component) {
  _inherits(AppSwitcherHome, _React$Component);

  function AppSwitcherHome() {
    _classCallCheck(this, AppSwitcherHome);

    return _possibleConstructorReturn(this, (AppSwitcherHome.__proto__ || Object.getPrototypeOf(AppSwitcherHome)).apply(this, arguments));
  }

  _createClass(AppSwitcherHome, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          other = _objectWithoutProperties(_props, ["className", "children"]);

      return _react2.default.createElement("div", {
        className: (0, _classnames2.default)("cdk-global-header__app-switcher-back-home-container", className)
      }, _react2.default.createElement("a", _extends({
        className: (0, _classnames2.default)("mdc-list-item", "cdk-global-header__app-switcher-back-home-anchor")
      }, other), _react2.default.createElement(_reactIcon.Icon, {
        className: (0, _classnames2.default)("mdc-list-item__graphic", "cdk-global-header__app-switcher-back-home-icon")
      }, "chevron_left"), _react2.default.createElement("span", {
        className: "cdk-global-header__app-switcher-back-home-text"
      }, children)));
    }
  }]);

  return AppSwitcherHome;
}(_react2.default.Component);

exports.default = AppSwitcherHome;